export default "__VITE_ASSET__CIVZ6cr2__"